import { useEffect } from 'react';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';

import type { PartnerInvoicesResponse } from '../useApi/useFetchPartnerInvoices';

const usePartnerInvoicesDialogue = (response?: PartnerInvoicesResponse): { showDialogue: () => void } => {
  const errorMessage = response?.errorMessage || '';

  const { provideProps, showDialogue } = useConfirmationDialogue();

  useEffect(() => {
    const handlers = {
      errorMessage: () => {
        provideProps({
          title: 'Error! There is a problem with the submitted parameters.',
          subTitle: errorMessage,
          status: 'error',
          confirm: {
            label: 'Stay here and try again',
            action: () => {},
          },
        });
      },
    };

    if (errorMessage) return handlers.errorMessage();

    return handlers.errorMessage();
  }, [errorMessage]);

  return { showDialogue };
};

export default usePartnerInvoicesDialogue;
